import React from 'react';

const UpdateSystemMiddleware = (Component) => {
  return (props) => {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <img src="/close_system2.png" alt="system" style={{ width: '500px', height: '500px' }} />
      </div>
    );
  };
};

export default UpdateSystemMiddleware;
